import type { ReactNode } from "react";

import { Card, Flex } from "antd";

import type { ProviderResolved } from "shell/api/types";

import { ThemeProvider } from "design-system/components/ThemeProvider";
import { ThreddLogo } from "design-system/icons";

import s from "./ProviderCard.module.css";
import { ProviderOptions } from "./ProviderOptions";

interface Props {
  children?: ReactNode;
  optionsProps?: {
    email: string;
    resolution: ProviderResolved;
    onReset: () => void;
    onProviderSelected: (provider: any, email?: string) => void;
    onPasswordLogin: (email: string) => void;
  };
}

export const ProviderCard = ({ children, optionsProps }: Props) => {
  const componentToRender = optionsProps ? (
    <ProviderOptions {...optionsProps} />
  ) : (
    children
  );

  return (
    <ThemeProvider>
      <Flex
        justify="center"
        align="center"
        className={s.container}
        data-testid="provider-discovery"
      >
        <Card className={s.card}>
          <ThreddLogo
            width={160}
            height={64}
            role="img"
            aria-label="Thredd"
            className={s.logo}
          />

          {componentToRender}
        </Card>
      </Flex>
    </ThemeProvider>
  );
};
